import React from 'react';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Link } from 'react-router-dom';
import { Briefcase, Activity, Video, MapPin, Users, ArrowRight, Heart, BookOpen, Calendar } from 'lucide-react';

export default function VisitorPage() {

  const quickLinks = [
    { id: 'projects', title: 'Découvrir nos Projets', description: 'Explorez nos initiatives dans les 4 provinces pilotes', link: '/projets', icon: Briefcase },
    { id: 'activities', title: 'Nos Activités', description: 'Consultez nos activités et rapports détaillés', link: '/activites', icon: Activity },
    { id: 'gallery', title: 'Galerie médias', description: 'Photos et vidéos de terrain', link: '/galerie', icon: Video },
    { id: 'formations', title: 'Formations FPT', description: 'Postuler ou demander une formation', link: '/formations', icon: BookOpen },
    { id: 'map', title: 'Carte Interactive', description: 'Visualisez nos provinces d\'intervention', link: '/carte', icon: MapPin },
    { id: 'calendar', title: 'Calendrier', description: 'Découvrez nos prochains événements', link: '/calendrier', icon: Calendar },
    { id: 'blog', title: 'Blog & Actualités', description: 'Lisez nos derniers articles', link: '/blog', icon: BookOpen },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />

      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-[#4A6B48] to-[#3B5539] text-white" data-testid="visitor-hero">
        <div className="container mx-auto px-6 text-center">
          <h1 
            className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
            data-testid="visitor-title"
          >
            Espace Visiteur
          </h1>
          <p className="text-lg max-w-2xl mx-auto opacity-95">
            Bienvenue ! Découvrez l&apos;impact de CRESA ASBL et tout ce que nous offrons à notre communauté.
          </p>
        </div>
      </section>

      {/* Quick Links */}
      <section className="section-padding bg-[#F9F8F6]" data-testid="quick-links-section">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 
              className="text-3xl sm:text-4xl font-bold text-[#2E332D] mb-4"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              Explorez Notre Univers
            </h2>
            <p className="text-[#5C665A] max-w-2xl mx-auto">
              Naviguez facilement à travers toutes nos sections.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {quickLinks.map((link) => (
              <Link 
                key={link.id} 
                to={link.link} 
                className="card group hover:border-[#4A6B48] transition-all"
                data-testid={`quick-link-${link.id}`}
              >
                <link.icon className="text-[#4A6B48] mb-4 group-hover:text-[#D87D4A] transition-colors" size={32} />
                <h3 
                  className="text-xl font-bold text-[#2E332D] mb-2 group-hover:text-[#4A6B48] transition-colors"
                  style={{ fontFamily: 'Cormorant Garamond, serif' }}
                >
                  {link.title}
                </h3>
                <p className="text-sm text-[#5C665A] mb-4">{link.description}</p>
                <div className="flex items-center text-[#4A6B48] text-sm font-medium">
                  Découvrir <ArrowRight className="ml-2" size={16} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding bg-[#D87D4A] text-white" data-testid="visitor-cta">
        <div className="container mx-auto px-6 text-center">
          <h2 
            className="text-3xl sm:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            Rejoignez-nous dans cette aventure
          </h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto opacity-95">
            Devenez membre ou soutenez nos actions pour un développement intégral durable en RD Congo.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/register" 
              className="bg-white text-[#D87D4A] px-8 py-3 rounded-full font-medium hover:bg-gray-100 transition-all inline-flex items-center justify-center"
              data-testid="visitor-register-cta"
            >
              <Users className="mr-2" size={20} />
              Devenir membre
            </Link>
            <Link 
              to="/dons" 
              className="border-2 border-white text-white px-8 py-3 rounded-full font-medium hover:bg-white hover:text-[#D87D4A] transition-all inline-flex items-center justify-center"
              data-testid="visitor-donate-cta"
            >
              <Heart className="mr-2" size={20} />
              Faire un don
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
